import React, { useState, useEffect } from "react";

export default function EnquiryForm() {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    course: "",
    location: "",
    phone: "",
    message: "",
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowForm(true);
    }, 2000);

    return () => clearTimeout(timer); // cleanup if component unmounts
  }, []);

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleWhatsApp = () => {
    const phoneNumber = "919600936470";
    const message = `*New Enquiry*\n\n*Name:* ${formData.name}\n*Email:* ${formData.email}\n*Phone:* ${formData.phone}\n*Course:* ${formData.course}\n*Location:* ${formData.location}\n*Message:* ${formData.message}`;
    
    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  const handleEmail = () => {
    const subject = "Enquiry from Website";
    const body = `Name: ${formData.name}%0D%0AEmail: ${formData.email}%0D%0APhone: ${formData.phone}%0D%0ACourse: ${formData.course}%0D%0ALocation: ${formData.location}%0D%0AMessage: ${formData.message}`;
    
    window.open(
      `mailto:stsclass@gmail.com?subject=${encodeURIComponent(subject)}&body=${body}`,
      "_blank"
    );
  };

  return (
    <>
      <button className="en-floating-btn" onClick={toggleForm}>
        Enquiry <i className="fas fa-comment-dots"></i>
      </button>

      {showForm && (
        <div className="en-form-overlay" onClick={toggleForm}>
          <div
            className="en-form-container"
            onClick={(e) => e.stopPropagation()}
            style={{ padding: "25px" }}
          >
            <h2 className="en-form-title">Enquiry Form</h2>
            
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              className="en-input"
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              className="en-input"
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              className="en-input"
            />
            <input
              type="text"
              name="course"
              placeholder="Course"
              value={formData.course}
              onChange={handleChange}
              className="en-input"
            />
            <input
              type="text"
              name="location"
              placeholder="Location"
              value={formData.location}
              onChange={handleChange}
              className="en-input"
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              className="en-textarea"
            ></textarea>

            <button
              onClick={handleWhatsApp}
              className="en-submit-btn"
              style={{
                background: "#25D366",
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <i className="fab fa-whatsapp" style={{ fontSize: "1.2rem" }}></i>{" "}
              Send via WhatsApp
            </button>

            <button
              onClick={handleEmail}
              className="en-submit-btn"
              style={{
                background: "#DB4437",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <i className="fas fa-envelope" style={{ fontSize: "1.2rem" }}></i>{" "}
              Send via Email
            </button>
          </div>
        </div>
      )}
    </>
  );
}
